import compareVars from '~/assets/services/compare/vars';

export default function () {
    return {
        showDifferencesFlag: false,
        toggleDifferenceText: compareVars.text.SHOW_DIFFERENCE,
    };
}
